export default __webpack_public_path__ + "static/TitilliumWeb-Bold-8d007be1ee9abdb973d904066795a2c7.woff2";